import { Outlet } from 'react-router-dom'
import App from './App'
import NavBar from './Misc/NavBar'
import QuoteDetails from './QuoteDetails/QuoteDetails'
import QuoteList from './QuoteList/QuoteList'
import QuoteValidation from './QuoteDetails/QuoteValidation'
import EditLines from './EditQuote/EditLines'
import LinesCustomView from './EditQuote/LinesCustomView'
import TechnicalRequest from './QuoteDetails/TechnicalRequest'
import SupplierList from './SupplierList/SupplierList'
import ManufacturerList from './ManufacturerList/ManufacturerList'
import GsaMasCatalog from './GsaMasCatalog/GsaMasCatalog'
import CatalogList from './CatalogList/CatalogList'

const routes = [
  {
    path: '/',
    element: <NavBarWrapper />,
    children: [
      {
        path: '/',
        element: <App />,
      },
      {
        path: '/quotes',
        element: <QuoteList />,
      },
      {
        path: '/quote/:quoteId',
        element: <QuoteDetails />,
      },
      {
        path: '/quote/:quoteId/validation',
        element: <QuoteValidation />,
      },
      {
        path: '/quote/:quoteId/lines',
        element: <EditLines />,
      },
      {
        path: '/quote/:quoteId/lines/customView',
        element: <LinesCustomView />,
      },
      {
        path: '/quote/:quoteId/technicalrequest',
        element: <TechnicalRequest />,
      },
      {
        path: '/supplier',
        element: <SupplierList />,
      },
      {
        path: '/manufacturer',
        element: <ManufacturerList />,
      },
      {
        path: '/gsamascatalog',
        element: <GsaMasCatalog />,
      },
      {
        path: '/catalogs',
        element: <CatalogList />,
      },
    ],
  },
]

function NavBarWrapper() {
  return (
    <div>
      <NavBar />
      <Outlet />
    </div>
  )
}

export default routes
